var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-card",class:{ 'modal-card_bundle': _vm.isBundle }},[(_vm.loading)?_c('LoaderOverScreen'):[(_vm.isBundle)?[_c('ProductCombo',{attrs:{"item":_vm.item,"isInlineCard":true}})]:[_c('Product',{attrs:{"item":_vm.item,"isInlineCard":true}})]]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }